import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

const selectFileStatus = (state: RootState) => state.video.file.status;

export const selectChangeSettingsDisabled = createSelector(
  [selectFileStatus],
  (s) => !(s === 'added' || s === 'idle')
);
